import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

interface HeadingProps {
  subtitle?: string;
  title: string;
  className?: {
    container?: string;
    subtitle?: string;
    title?: string;
  };
}

export function Heading({ subtitle, title, className }: HeadingProps) {
  return (
    <div className={cn('flex flex-col gap-4', className?.container)}>
      {!!subtitle && (
        <p className={cn('text-sm text-muted-foreground sm:text-base', className?.subtitle)}>
          {subtitle}
        </p>
      )}

      <HtmlRendererRaw
        as="h2"
        className={cn(
          'text-[28px] font-bold leading-[1.1] tracking-tighter text-black sm:text-3xl sm:leading-[1.1] lg:text-[38px] lg:leading-[1.1]',
          className?.title,
        )}
        html={title}
      />
    </div>
  );
}
